document.addEventListener("DOMContentLoaded", () => {
  console.log('banle item running')
  const bandelsContainer = document.querySelector(".bandels_contaioner");
  const quantityTitle = document.querySelector(".quantity_title span");
  const productSubmitButton = document.querySelector(".product-form__submit");
  const frequencyTitle = document.querySelector(".frequency_title span");

  const quantityInput = document.querySelector("#quantity-cta");

  if (
    !bandelsContainer ||
    !quantityTitle ||
    !frequencyTitle ||
    !quantityInput
  ) {
    console.error("Error: Required elements are missing from the DOM.");
    return;
  }

  // Keep track of the currently selected bundle
  let currentLabelElement = null;

  // Function to extract percentage from most_popular element
  const extractPercentage = (labelElement) => {
    const mostPopularElement = labelElement.querySelector(".most_popular");
    let percentage = "20"; // Default percentage

    if (mostPopularElement) {
      const spanElement = mostPopularElement.querySelector("span");
      if (spanElement) {
        const percentageText = spanElement.textContent.trim(); // e.g., "15% OFF"
        const percentageMatch = percentageText.match(/(\d+)%/); // Extract number
        if (percentageMatch && percentageMatch[1]) {
          percentage = percentageMatch[1]; // Use the extracted percentage
        } else {
          console.warn("No valid percentage found, using default 20%.");
        }
      }
    } else {
      console.warn(
        "No '.most_popular' element found inside the label, using default 20%."
      );
    }

    return percentage;
  };

  // Function to update prices and Add to Cart button
  const updatePricesAndButton = (labelElement) => {
    let isSubscription;
    if (!labelElement) {
      console.warn("No `.bandels_item` provided for price update.");
      return;
    }
    currentLabelElement = labelElement; // Store the current selection

    console.log('checking current label',currentLabelElement)

    // Extract the percentage from the most_popular span
    const percentage = extractPercentage(labelElement);

    // Get the base price from the regular price element
    const regularPriceElement = document.querySelector(
      ".price__sale s.price-item--regular"
    );
    const basePriceRaw = regularPriceElement
      ? regularPriceElement.textContent.trim()
      : "0";
    const basePrice = parseFloat(basePriceRaw.replace(/[^\d.-]/g, "")) || 0;

    // Get quantity from heading
    const headingElement = labelElement.querySelector(".heading_Pack");
    let quantity = 1;
    if (headingElement) {
      const quantityMatch = headingElement.textContent.match(/(\d+)/);
      if (quantityMatch && quantityMatch[1]) {
        quantity = parseInt(quantityMatch[1]);
      }
      quantityTitle.textContent = headingElement.textContent;

      quantityInput.value = quantity;
    }

    // Get bundle prices
    const bundleElement = labelElement.querySelector(".price__bundle");
    if (!bundleElement) {
      console.error("No `.price__bundle` found inside `.bandels_item`.");
      return;
    }
 const originalPriceMainRaw = bundleElement.getAttribute('data-price-orginal');
   
    const originalPriceMain = parseFloat(originalPriceMainRaw?.replace(/[^\d.-]/g, ""));
    // Get and parse prices from data attributes
    const bundlePriceRaw = bundleElement.getAttribute("data-price") || "0";
    const bundleOnePriceRaw =
      bundleElement.getAttribute("data-one-price") || "0";
    const bundlePrice = parseFloat(bundlePriceRaw.replace(/[^\d.-]/g, ""));
    const bundleOnePrice = parseFloat(
      bundleOnePriceRaw.replace(/[^\d.-]/g, "")
    );

    // Calculate original total
    const originalTotal = originalPriceMain * quantity;

    // Determine which option is currently selected
    const subscriptionOption = document.querySelector(
      ".loop-widget-purchase-option:not(.loop-widget-purchase-option-onetime)"
    );
    if(subscriptionOption)
    {
        isSubscription = subscriptionOption.classList.contains(
      "loop-widget-purchase-option-selected"
    );

        if (isSubscription) {
      frequencyTitle.textContent = `Subscribe & Save 20%`;
    } else {
      frequencyTitle.textContent = "One-time Purchase";
    }
    }
   

    // Update frequency title based on selected option and extracted percentage
  

    // Update prices based on selected purchase option
    const displayPrice = isSubscription ? bundlePrice : bundleOnePrice;
    // Choose the correct comparison price based on purchase type
    const comparisonPrice = isSubscription ? bundleOnePrice : originalTotal;
    const stickyButton = document.querySelector(
      ".sticky-addtocart-button-trigger"
    );
    stickyButton.innerHTML = `Add To Cart - $${displayPrice.toFixed(
      2
    )} ${displayPrice !== comparisonPrice ? `<s>$${comparisonPrice.toFixed(2)}</s>` : ''}`;
    // Update button and prices with correct comparison price
    productSubmitButton.innerHTML = `Add To Cart - $${displayPrice.toFixed(
      2
    )}
   ${displayPrice !== comparisonPrice ? `<s>$${comparisonPrice.toFixed(2)}</s>` : ''}
    
    `;

    // Update purchase option displays
    document
      .querySelectorAll(".loop-widget-purchase-option")
      .forEach((container) => {
        const savings = Math.round(bundleOnePrice - bundlePrice);
        const currentPrice = container.querySelector(
          ".loop-widget-purchase-option-price"
        );
        const compareAtPrice = container.querySelector(
          ".loop-widget-purchase-option-compare-at-price"
        );

        if (
          container.classList.contains("loop-widget-purchase-option-onetime")
        ) {
          if (currentPrice)
            currentPrice.textContent = `$${bundleOnePrice.toFixed(2)}`;
        } else {
          if (currentPrice)
            currentPrice.textContent = `$${bundlePrice.toFixed(2)}`;
        }

        if (compareAtPrice) {
          compareAtPrice.textContent = `$${bundleOnePrice.toFixed(2)}`;
        }
        const sellingPlanGroup = document.querySelector(
          "[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-header"
        );
        const discountBadge = document.querySelector(".discount-badge");
        if (discountBadge) {
          discountBadge.textContent = `SAVE $${savings.toFixed(2)}`;
        } else if (sellingPlanGroup) {
          // Create and insert the badge if it doesn't already exist
          sellingPlanGroup.insertAdjacentHTML(
            "afterbegin",
            `<span class="discount-badge">SAVE ${savings.toFixed(
              2
            )}</span>`
          );
        }
      });
  };

  // Update prices and button on bundle selection
  bandelsContainer.addEventListener("click", (event) => {
    // event.preventDefault();
    const labelElement = event.target.closest(".bandels_item");
    if (labelElement) {
      updatePricesAndButton(labelElement);
    }
  });

  // Add click event listeners for purchase options
  setTimeout(function () {
    document
      .querySelectorAll(".loop-widget-purchase-option")
      .forEach((option) => {
        // console.log(option,"option")
        option.addEventListener("click", function () {
          // Handle the click event for purchase options
          const isSubscription = !this.classList.contains(
            "loop-widget-purchase-option-onetime"
          );

          // Update selected states
          document
            .querySelectorAll(".loop-widget-purchase-option")
            .forEach((opt) => {
              opt.classList.remove("loop-widget-purchase-option-selected");
            });
          this.classList.add("loop-widget-purchase-option-selected");

          // Simulate click on the currently selected bundle if it exists
          if (currentLabelElement) {
            currentLabelElement.click();
          } else {
            // If no bundle is selected, click the first one
            const firstBundle = document.querySelector(".bandels_item");
            if (firstBundle) {
              firstBundle.click();
            }
          }
        });
      });
  }, 2000);

  setTimeout(function () {
    const subscriptionSelector = document.querySelector(
      ".loop-widget-sp-selector"
    );
    console.log("subscriptionSelector", subscriptionSelector);
    if (subscriptionSelector) {
      subscriptionSelector.addEventListener("change", function () {
        if (currentLabelElement) {
          currentLabelElement.click();
        } else {
          const firstBundle = document.querySelector(".bandels_item");
          if (firstBundle) {
            firstBundle.click();
          }
        }
      });
    }
  }, 2000);

  // Initial update after a delay
  setTimeout(() => {
    console.log("Initial update triggered");
    const firstBundle = document.querySelector(".bandels_item");
    if (firstBundle) {
      updatePricesAndButton(firstBundle);
    }
  }, 2000);
});
